module.exports = __webpack_public_path__ + "static/bg_social_medias-75b08e80b5b24ad37a9eb1c8f3b7510e.webp";